import React, { useMemo } from "react"
import Menu from "../Menu/Menu"
import { HeaderTypes, ItemsProps } from "../Header"
import { graphql, useStaticQuery } from "gatsby"
import { ItemType } from "../Menu/MenuGroup/MenuGroup"

enum ProductTypes {
  INSIGHT = "insight",
  COLLECTOR = "collector",
}

export type ProductsQuery = {
  allProductsJson: {
    nodes: Array<{ data: ItemType[] }>
  }
}

const ProductsMenu = ({ showOptions, handleToggleOptions }: ItemsProps) => {
  // Graphql Data
  const data = useStaticQuery<ProductsQuery>(ProductsMenuItemsQuery)

  // Organize Insight and Collector
  const productItems = useMemo(() => {
    const firstNode = data.allProductsJson.nodes[0]
    if (!firstNode) return { insight: [], collector: [] }

    const renamedData = firstNode.data.map(item => ({
      slug: item.slug,
      name: item.title!, // change title to name
      type: item.type,
    }))

    return {
      [ProductTypes.INSIGHT]: [
        { slug: "dashboard", name: "Dashboard", type: "insight" },
        { slug: "textanalytics", name: "Sentiment", type: "insight" },
        { slug: "actionhub", name: "Action Hub", type: "insight" },
        { slug: "integration", name: "Integeration", type: "insight" },
      ],
      [ProductTypes.COLLECTOR]: renamedData.filter(
        x => x.type === ProductTypes.COLLECTOR
      ),
    }
  }, [data.allProductsJson.nodes])

  return (
    <Menu
      title={HeaderTypes.PRODUCTS}
      items={productItems}
      showOptions={showOptions}
      handleToggleOptions={handleToggleOptions}
    />
  )
}

export default ProductsMenu

export const ProductsMenuItemsQuery = graphql`
  query ProductsMenuItemsQuery {
    allProductsJson {
      nodes {
        data {
          slug
          title
          type
        }
      }
    }
  }
`
